import React, { Fragment } from 'react'

const PdfCards = ({ ...props }) => {

    const filteredData = props.filteredData
    const filteredColumns = props.filteredColumns
    const data = props.rawData
    const from = props.from 

    /*
     * We use different page break index for different types of report to avoid breaking content/card. 
     */
    const pageBreak = ( index ) => {
        if( (from === 'Course Report' || from === 'Lessons Report' || from === 'Topics Report' || from === 'Assignments Report' ||  from === 'Enrolled Courses' ) && !(index === 4 || (index > 4 && (index - 4) % 6 === 0)) ){
           return  
        }

        if( filteredColumns.length >= 5 && from === 'User Report' && !(index === 3 || (index > 3 && (index - 3) % 4 === 0)) ){
            return 
        }

        if( (from === 'Enrolled Users' || ( filteredColumns.length <= 4 && from === 'User Report' ) ) && !(index === 4 || (index > 4 && (index - 4) % 5 === 0)) ){
            return
        }
        
        return <div className="page-break" />
    }

    const cardTitle = ( index ) => {
        const content = () =>{
            switch( from ){
                case 'Course Report':
                case 'Enrolled Courses':
                    return <span className='msync-exported-pdf-course-report__course-name'>{data[index].course}</span>
                case 'Enrolled Users':
                case 'User Report':
                    return (<>
                                <span className='msync-exported-pdf-course-report__course-name'>{data[index].name}</span>
                                <span className='msync-exported-pdf-course-report__email'>{data[index].email}</span>
                            </>)
                case 'Lessons Report':
                    return <span className='msync-exported-pdf-course-report__course-name'>{data[index].lessonName}</span>
                case 'Topics Report':
                    return <span className='msync-exported-pdf-course-report__course-name'>{data[index].topicName}</span>
                case 'Assignments Report':
                    return <span className='msync-exported-pdf-course-report__course-name'>{data[index].assignmentName}</span>
                default: 
                    return ''
            }
        }

        return (
            <div className="msync-exported-pdf-course-report__card-title">
                { content() }
            </div>
        )
    }
    
    const countName = ( count, column ) => {
        if( from !== 'Course Report') return
        if( from === 'Course Report' && column.id === 'courseId' ) return 

        return Number( count ) > 1 ? ' students' : ' student'
    }

    return(
        <div className='msync-exported-pdf-course-report'>
            {filteredData.map((rowData, index) => (
                <Fragment key={`${from}_${index}`}>
                    { pageBreak( index ) }
                    <div key={`${from}_container_${index}`} className='msync-exported-pdf-course-report__course'>
                        { cardTitle( index ) }
                        <table>
                            <thead>
                                <tr>
                                {filteredColumns.map(column => (
                                    <th key={`${from}_th_${column.id}_${index}`} className='msync-exported-pdf-course-report__table-head'>{column.displayName}</th>
                                    ))}
                                </tr>
                            </thead>
                        <tbody>
                            <tr>
                            {filteredColumns.map(column => (
                                <td key={`${from}_td_${column.id}_${index}`} className='msync-exported-pdf-course-report__table-body'>{rowData[column.id]}{countName( rowData[column.id], column )}</td>
                                ))}
                            </tr>
                        </tbody>
                        </table>
                    </div>
                </Fragment>
            ))}
        </div>
    )
}

export default PdfCards